// extracted by mini-css-extract-plugin
var _1 = "ListItemContent-moduledescription__jaeCE";
var _2 = "ListItemContent-moduledisabled__EyK0t";
var _3 = "ListItemContent-modulehover___lfKf";
var _4 = "ListItemContent-moduletext__Rd9WF";
var _5 = "ListItemContent-moduletextContainer__LZn5S";
export { _1 as "description", _2 as "disabled", _3 as "hover", _4 as "text", _5 as "textContainer" }
